import { useChatStore } from '@/store/chatStore';
import { useConfigStore } from '@/store/configStore';
import { translateConfigValue } from '@/utils/translateConfigValue';
import { X } from 'lucide-react';

const ChatAlert = () => {
  const { config } = useConfigStore();
  const language = config.language ?? 'de';
  const thanksMessage = translateConfigValue(config?.ui?.feedback?.thanks, language);

  const { setShowFeedbackAlert } = useChatStore();

  return (
    <div className="flex w-full items-center justify-between rounded-xl border border-border bg-white py-[7px] pl-[7px] pr-[21px]">
      <div className="flex items-center gap-[6px]">
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.3">
            <path
              d="M19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19C6 11.8203 11.8203 6 19 6Z"
              stroke="#0890BF"
              stroke-width="2"
            />
          </g>
          <g opacity="0.1">
            <path
              d="M19 1C28.9411 1 37 9.05887 37 19C37 28.9411 28.9411 37 19 37C9.05887 37 1 28.9411 1 19C1 9.05887 9.05887 1 19 1Z"
              stroke="#0890BF"
              stroke-width="2"
            />
          </g>
          <g clip-path="url(#clip0_18654_1935)">
            <path
              d="M19.0003 22.3333V19M19.0003 15.6667H19.0087M27.3337 19C27.3337 23.6024 23.6027 27.3333 19.0003 27.3333C14.398 27.3333 10.667 23.6024 10.667 19C10.667 14.3976 14.398 10.6667 19.0003 10.6667C23.6027 10.6667 27.3337 14.3976 27.3337 19Z"
              stroke="#0890BF"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_18654_1935">
              <rect width="20" height="20" fill="white" transform="translate(9 9)" />
            </clipPath>
          </defs>
        </svg>
        <div className="flex flex-col gap-[4px]">
          <span className="text-sm font-medium text-widget-text-secondary">{thanksMessage}</span>
        </div>
      </div>
      <X
        className="cursor-pointer text-[#A4A7AE]"
        size={20}
        onClick={() => setShowFeedbackAlert(false)}
      />
    </div>
  );
};

export default ChatAlert;
